import { IDeleteObraChecklistServicosUseCase } from "../../../presentation/useCases/delete/delete_obra_checklist_servicos_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteObraChecklistServicosUseCase
 */

export class DeleteObraChecklistServicosUseCase implements IDeleteObraChecklistServicosUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteObraChecklistServicos(
    idsObraChecklistServicos: number[],
  ): Promise<void> {
    await this.repository.deleteObraChecklistServicos(idsObraChecklistServicos);
  }
}
